<template>
  <div class="discover-page">
    <div class="main-wrapper">
      <div class="content main_content">
        <side-menu></side-menu>

        <div class="chat page overflow-y-auto">
          <div :class="{'page-header-open': showFilters}" class="page-section page-header px-3 py-3 bg-white border-bottom d-flex justify-content-between align-items-center">
            <h4 class="sidebar-title">
              <span v-if="isOperator">{{$t('start_new_chat')}}</span>
              <span v-else>{{$t('discover_text')}}</span>
            </h4>

            <a href="#" class="toggle-link" @click.prevent="showFilters = !showFilters">
              <span v-if="showFilters">{{$t('discover_filters_hide')}}</span>
              <span v-else>
                <i class="bx bx-filter-alt"></i>
                {{$t('discover_filters_show')}}
              </span>
            </a>
          </div>

          <div v-if="showFilters" :class="{'filters-open': showFilters}" class="filters page-section px-3 py-2 bg-white shadow-sm border-bottom d-flex justify-content-between align-items-center">
            <div class="d-flex justify-content-between w-full align-items-end row g-2">
              <div>
                <div class="row g-2">
                  <div class="col-12 col-md-4 col-lg-4">
                    <div class="input">
                      <label for="country-input">{{$t('discover_filters_country_title')}}</label>
                      <vue-select id="country-input" v-model="filters.country" :settings="vueSelectSettings" :options="countriesOptions" :placeholder="$t('discover_filters_country_placeholder')"/>
                    </div>
                  </div>

                  <div class="col-12 col-md-4 col-lg-4">
                    <Range :label="$t('discover_filters_age')" :min-title="$t('discover_filters_hover_min')" :max-title="$t('discover_filters_hover_max')" @min="filters.min_age = $event" @max="filters.max_age = $event"/>
                  </div>
                </div>
              </div>

              <div class="col-12 col-xs-6">
                <button type="submit" class="btn btn-primary btn-filter btn-size justify-content-center w-auto h-auto" @click.prevent="applyFilters"
                        style="height: 48px !important;"
                >
                  <div v-if="loadingFilters" class="loading-spinner me-2"></div>
                  <span>{{$t('discover_filters_apply')}}</span>
                </button>
              </div>
            </div>
          </div>

          <div class="py-2 page-section">
            <div v-if="loading" class="w-full h-full d-flex justify-content-center align-items-center">
              <Loading/>
            </div>

            <a-empty v-else-if="!filteredPeople.length" description="No people found"/>

            <div v-else class="d-flex flex-wrap align-items-stretch row g-2 cards">
              <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                   v-for="(user, index) in [...filteredPeople]"
                   :key="index"
              >
                <div v-if="user.profile" class="card h-100 p-0 flex-grow-1 shadow-sm">
                  <div class="card-img card-img-top position-relative">
                    <img
                      v-if="user.profile?.profile_picture_url"
                      :src="user.profile?.profile_picture_url"
                      :alt="user.profile.display_name"
                      class="img-fluid"
                    />

                    <div v-else class="initials-image">{{user.profile.display_name[0].toUpperCase()}}</div>

                    <div class="action-buttons position-absolute">
                      <a-tooltip :mouseEnterDelay="0" :mouseLeaveDelay="0" :title="$t('discover_view_profile')" placement="bottom">
                        <router-link
                          :to="`/user/${user.username}/profile`"
                          class="action-button info border shadow-lg"
                        >
                          <i class="bx bx-user"></i>
                        </router-link>
                      </a-tooltip>

                      <a-tooltip :mouseEnterDelay="0" :mouseLeaveDelay="0" color="#ffa300" :title="$t('discover_send_message')" placement="bottom">
                        <router-link
                          :to="{name: 'chat-conversation', params: {id: user.username}}"
                          class="action-button border shadow-lg message"
                        >
                          <i class="bx bx-message"></i>
                        </router-link>
                      </a-tooltip>
                    </div>
                  </div>

                  <div class="card-body text-center">
                    <h5>
                      <span class="position-relative">
                        <i :class="{active: activeUsers.includes(user.id)}" class="bx bxs-circle status-icon"></i>
                        {{ user.profile.display_name }}
                      </span>
                    </h5>

                    <div class="flex text-muted mb-2">
                      <span>{{ $t('discover_age') }} {{ user.profile.age }}</span>
                      <span v-if="user.profile.country || user.profile.city"> &bullet; {{userLocation(user)}}</span>
                    </div>

                    <p class="fst-italic mb-0">"{{ user.profile.chat_status }}"</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      loadingFilters: false,
      vueSelectSettings: {
        allowClear: true,
        closeOnSelect: true,
      },
      showFilters: false,
      loading: true,
      filters: {
        country: '',
        city: '',
        min_age: 18,
        max_age: 100,
      },
    }
  },

  mounted() {
    this.init();
  },

  computed: {
    ...mapGetters({
      people: 'people',
      activeUsers: 'chat/activeUsers',
      countries: 'misc/countries',
      isOperator: 'isOperator',
    }),

    countriesOptions() {
      return this.countries;
    },

    filteredPeople() {
      return this.people.sort((a, b) => a.online ? -1 : 1);
    },
  },

  methods: {
    userLocation(user) {
      if (user.profile.country) {
        let country = this.countries.find(e => e.id === user.profile.country);

        return country ? country.text : '';
      }

      return '';
    },

    async init() {
      await this.applyFilters();
    },

    async applyFilters() {
      this.loading = true;
      this.loadingFilters = true;
      await this.$store.dispatch('discovery', this.filters);
      this.loading = false;
      this.loadingFilters = false;
    },
  },
}
</script>
